import { LoaderFunction } from "react-router-dom";

import ContentRequests from "@/api/content/content.requests.ts";
import { queryClient } from "@/api/query-client.tsx";
import { CONTENT_KEYS } from "@/hooks/api/content.hooks.ts";
import { lang } from "@/utils/funcs.ts";

export const collectionDetailLoader: LoaderFunction = ({ params }) => {
  const { id: paramId } = params as { id: string };
  const id = parseInt(paramId);

  const collectionDetailCache = queryClient.getQueryData(CONTENT_KEYS.collectionDetail(lang, id, 48));
  if (collectionDetailCache) return collectionDetailCache;

  return queryClient.fetchInfiniteQuery({
    queryKey: CONTENT_KEYS.collectionDetail(lang, id, 48, ""),
    queryFn: ({ pageParam = 0 }) =>
      ContentRequests.getCollectionDetail({ id, limit: 48, offset: pageParam * 48, search: "" }),
    initialPageParam: 0,
    staleTime: 1000 * 60 * 5,
  });
};
